const VideoType = {
	YOUTUBE: "YouTube",
	VIMEO: "Vimeo",
	CLOUDINARY: "Cloudinary",
};

export default VideoType;
export { VideoType };
